import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";

export default function CategoriesPage() {
  const [cats, setCats] = useState([]);
  useEffect(() => { api.get("/categories").then((r) => setCats(r.data)); }, []);
  const iconMap = { ott: "🎬", ai: "✦", productivity: "◆", vpn: "◈", music: "♪", learning: "◇", design: "◆", gaming: "▲" };

  return (
    <div className="max-w-7xl mx-auto px-5 md:px-8 py-14">
      <div className="mb-10">
        <div className="kyro-overline">Categories</div>
        <h1 className="font-display font-black text-4xl md:text-6xl tracking-tighter mt-3">Every corner of your stack</h1>
        <p className="text-kyro-mute mt-3 max-w-2xl">From binge-worthy OTT to bleeding-edge AI. Pick a lane.</p>
      </div>
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {cats.map((c, i) => (
          <motion.div key={c.slug} initial={{ opacity: 0, y: 12 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: i * 0.05 }}>
            <Link to={`/shop?category=${c.slug}`} data-testid={`categories-page-${c.slug}`} className="block kyro-card kyro-hover-lift p-8 group">
              <div className="text-3xl font-display text-[#FF4433] mb-6">{iconMap[c.slug] || "◇"}</div>
              <h3 className="font-display font-bold text-2xl mb-2">{c.name}</h3>
              <p className="text-sm text-kyro-mute mb-6">{c.tagline}</p>
              <span className="inline-flex items-center gap-1 text-sm text-[#FF4433] group-hover:gap-2 transition-all">Explore <ArrowRight className="w-3.5 h-3.5" /></span>
            </Link>
          </motion.div>
        ))}
      </div>
    </div>
  );
}
